module.exports = __webpack_public_path__ + "static/media/icon-youtube.e646daff.svg";